import React from 'react';
import { styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { CalendarTodayOutlined } from '@mui/icons-material';
import moment from 'moment';
import { Colors } from 'library';

interface RDatePickerProps {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
}

export function RDatePicker({ value, onChange, placeholder = 'Pick a date' }: RDatePickerProps) {
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <StyledDatePicker
                value={value ? moment(value) : null}
                onChange={(newValue: moment.Moment | Date | null) =>
                    onChange(newValue ? moment(newValue).format('YYYY-MM-DD') : '')
                }
                format="MM/DD/YYYY"
                slots={{
                    openPickerIcon: StyledCalendarIcon,
                }}
                slotProps={{
                    textField: {
                        placeholder,
                        fullWidth: false,
                    },
                    inputAdornment: {
                        position: 'start',
                    },
                    openPickerButton: {
                        sx: { color: Colors.mediumGrey },
                    },
                }}
            />
        </LocalizationProvider>
    );
}

function StyledCalendarIcon() {
    return <CalendarTodayOutlined sx={{ fontSize: 20 }} />;
}

const StyledDatePicker = styled(DatePicker)({
    maxWidth: 280,
    '& .MuiOutlinedInput-root': {
        borderRadius: 24,
        backgroundColor: Colors.faintGrey,
        fontSize: 14,
        fontFamily: 'inherit',
        color: Colors.darkNavy,
        '& fieldset': {
            borderColor: Colors.lightGrey,
        },
        '&:hover fieldset': {
            borderColor: Colors.mediumGrey,
        },
        '&.Mui-focused fieldset': {
            borderColor: Colors.mediumGrey,
            borderWidth: 1,
        },
    },
    '& .MuiOutlinedInput-input': {
        padding: '10px 14px 10px 0',
    },
    '& .MuiInputLabel-root': {
        display: 'none',
    },
});
